import { DatePipe } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DATE_FORMAT } from '../models/data-format';

@Pipe({
  name: 'ellapseDate'
})
export class EllapseDatePipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe,
    @Inject(DATE_FORMAT) private dateFormat: string
  ) { }
  // parameter format only used as date format when dateFormat is null and format is not ellapse
  // dateFormat always have the priority if have
  // now DATE_FORMAT has no time part, some date field in Report page has both of date and time. so add a showTime parameter.
  transform(value: string | Date, format: string = 'dd-MMM-yyyy HH:mm aa', showTime: boolean = false, plain: boolean = false, timezone: string = null, locale: string = null): string {
    let date = null;
    if (value) {
      if (typeof (value) === 'string' && value.startsWith('/Date('))
        date = new Date(parseInt(value.match(/\d+/)[0]));
      else
        date = new Date(value);
    }
    else {
      return '';
    }
    let dateFormat = this.dateFormat;
    if (showTime) {
      dateFormat += ' HH:mm aa';
    }
    const dateString = this.datePipe.transform(date, dateFormat || format, timezone, locale);

    if (!plain) {
      let tip = '';
      let cls = 'time-stamp ';
      if (date) {
        let diffInMin = Math.round((new Date().getTime() - date.getTime()) / (1000 * 60));
        const beforeOrAfter = diffInMin >= 0 ? 'ago' : 'later';
        diffInMin = Math.abs(diffInMin);
        if (diffInMin < 60) {
          cls += 'minute-level';
          tip = `${diffInMin} mins`;
        }
        else if (diffInMin < 60 * 24) {
          cls += 'hour-level';
          tip = `${Math.round(diffInMin / 60)} hours`;
        }
        else if (diffInMin < 60 * 24 * 30) {
          cls += 'day-level';
          tip = `${Math.round(diffInMin / 60 / 24)} days`;
        }
        else if (diffInMin < 60 * 24 * 365) {
          cls += 'month-level';
          tip = `${Math.round(diffInMin / 60 / 24 / 30)} months`;
        }
        else {
          cls += 'year-level';
          tip = `${Math.round(diffInMin / 60 / 24 / 365)} years`;
        }
        tip = `${tip} ${beforeOrAfter}`;
      }
      // special format for display elapse time, currently used in workflow chart tip
      if (format == 'elapse') {
        return tip;
      }

      return `<span class="${cls}" title="${tip}">${dateString}</span>`;
    }
    else {
      return dateString;
    }
  }

}
